import { ScanFace, BarChart3, ShoppingCart } from "lucide-react";

const steps = [
  {
    num: 1,
    icon: ScanFace,
    tag: "Your skin, first",
    title: "Pick your concern",
    description: "Tell us what you're dealing with — breakouts, oiliness, sensitivity, or something else. Everything on Zeel filters to match your skin from here.",
  },
  {
    num: 2,
    icon: BarChart3,
    tag: "See what worked",
    title: "Explore real routines",
    description: "Browse routines shared by people with skin like yours. See exactly which products they used, in which order. Community votes on product results.",
  },
  {
    num: 3,
    icon: ShoppingCart,
    tag: "Make your move",
    title: "Shop what's proven",
    description: "Add individual products or the full routine in one go. Every product links back to the community experiences behind it — so you know exactly why it's there.",
  },
];

export const HowItWorksSection = () => (
  <section className="py-20 px-4 bg-[#F7F5F0]" data-testid="how-it-works-section">
    <div className="max-w-5xl mx-auto">
      {/* Header */}
      <div className="text-center mb-12">
        <p className="text-xs font-bold tracking-[0.2em] text-[#5B6BA8]/70 uppercase mb-3">How It Works</p>
        <h2 className="text-2xl sm:text-3xl font-semibold mb-3 text-gradient-brand" data-testid="how-it-works-heading">
          From your skin concern to a routine that works
        </h2>
        <p className="text-sm sm:text-base text-muted-foreground">
          Three steps. Real people. No guesswork.
        </p>
      </div>

      {/* Option B: Separate cards with top accent border */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
        {steps.map((step) => (
          <div
            key={step.num}
            className="relative bg-white rounded-2xl border border-slate-200/60 p-8 flex flex-col overflow-hidden hover:shadow-md transition-shadow"
            data-testid={`how-step-${step.num}`}
          >
            {/* Top accent gradient line */}
            <div className="absolute top-0 left-0 right-0 h-1.5 opacity-40" style={{ background: 'linear-gradient(90deg, #3B5AC6, #6B4FA8, #A855A0, #D946A8)' }} />

            {/* Icon */}
            <div className="w-12 h-12 rounded-xl bg-[#4A55A6]/[0.08] flex items-center justify-center mb-5">
              <step.icon className="w-5 h-5 text-[#4A55A6]" />
            </div>

            {/* Tag with step number */}
            <p className="text-sm font-semibold text-[#6B7280] mb-1">
              <span className="text-[#6B7280]/50 mr-1">{step.num}.</span> {step.tag}
            </p>

            {/* Title + description */}
            <h3 className="text-lg font-bold text-gradient-brand mb-2" style={{ display: 'inline-block' }}>{step.title}</h3>
            <p className="text-sm text-muted-foreground leading-relaxed">{step.description}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);
